import { render, staticRenderFns } from "./SQuesFortyFive.vue?vue&type=template&id=6d930d95&scoped=true&"
import script from "./SQuesFortyFive.vue?vue&type=script&lang=js&"
export * from "./SQuesFortyFive.vue?vue&type=script&lang=js&"
import style0 from "./SQuesFortyFive.vue?vue&type=style&index=0&id=6d930d95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d930d95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
